interface DividerWithLabelProps {
  label: string
  className?: string
}

export function DividerWithLabel({ label, className = '' }: DividerWithLabelProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex-1 h-px bg-border" />
      <span className="text-xs text-muted-foreground uppercase tracking-wider">
        {label}
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  )
}
